// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon--E2XOZEqa6l0_0nJcEPkM","iconFlipped":"iconFlipped--oKYgSh1XENQ0nC4Rzviw"};